import { render, staticRenderFns } from "./Buchung.vue?vue&type=template&id=6818e98a&scoped=true&"
import script from "./Buchung.vue?vue&type=script&lang=js&"
export * from "./Buchung.vue?vue&type=script&lang=js&"
import style0 from "./Buchung.vue?vue&type=style&index=0&id=6818e98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818e98a",
  null
  
)

export default component.exports